const maxItemWidth = 312;

/**
 *
 */
export const calcItemsPerPage = (
  stageClientWidth: number,
  gap: number,
  cut: number,
  outerGap: number,
): number =>
  Math.max(1, Math.ceil((stageClientWidth - outerGap - maxItemWidth * cut) / (gap + maxItemWidth)));
